/// <amd-module name="Build/Admin/Common/Actions/JobActions" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgentJobRequest } from "DistributedTask/Client/Contracts/TaskAgent";

export class JobActions {
    public jobUpdated = new Action<TaskAgentJobRequest>();
    public jobsUpdated = new Action<TaskAgentJobRequest[]>();
}
